import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { IndexComponent } from './pages/index/index.component';
import { CalibrationsComponent } from './pages/calibrations/calibrations.component';
import { ContactComponent } from './pages/contact/contact.component';
import { UsComponent } from './pages/us/us.component';
import { ServicesComponent } from './pages/services/services.component';
import { SellEquipmentComponent } from './pages/sell-equipment/sell-equipment.component';
import { RepairEquipmentComponent } from './pages/repair-equipment/repair-equipment.component';
import { TrainingComponent } from './pages/training/training.component';
import { AccreditationsComponent } from './pages/accreditations/accreditations.component';
import { ThanksComponent } from './pages/thanks/thanks.component';
import { EnumToArrayPipe } from './pipes/enum-to-array.pipe';
import { FilterPipe } from './pipes/filter.pipe';
import { SharedModule } from './modules/shared/shared.module';

// Components
import { EquipmentComponent } from './components/equipment/equipment.component';

// Layouts
import { IndexLayoutComponent } from './layouts/index-layout/index-layout.component';
import { CalibrationsLayoutComponent } from './layouts/calibrations-layout/calibrations-layout.component';
import { ContactLayoutComponent } from './layouts/contact-layout/contact-layout.component';
import { SecurityLayoutComponent } from './layouts/security-layout/security-layout.component';

@NgModule({
  declarations: [
    AppComponent,
    IndexComponent,
    CalibrationsComponent,
    ContactComponent,
    UsComponent,
    ServicesComponent,
    EnumToArrayPipe,
    EquipmentComponent,
    FilterPipe,
    SellEquipmentComponent,
    RepairEquipmentComponent,
    TrainingComponent,
    AccreditationsComponent,
    ThanksComponent,
    IndexLayoutComponent,
    CalibrationsLayoutComponent,
    ContactLayoutComponent,
    SecurityLayoutComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    SharedModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
